import React, {useState} from 'react'
import "./Header.scss"

export default function Header() {
  const [display, setDisplay] = useState(false)
  return (
    <div className='header row row-cols-2 g-0' >
      <div className='col-6 col-lg-3'>
        <a href="/">
          <img src="/logos/logo-grande.png" alt="Logo grande de Kuska" />
        </a>
      </div>
      <div className='col-6 d-lg-none d-flex justify-content-end align-items-center mobile-list'>
        <img src="/iconos/menu.png" alt="Menu Logo" onClick={()=>setDisplay(!display)} />
      </div>
      <div 
      className={`col-12 col-lg-9 ${display?"d-flex":"d-none"} flex-column flex-lg-row justify-content-end align-items-center d-lg-flex`}
      >
        <a href="/#como-funciona">Cómo funciona</a>
        <a href="/#caracteristicas">Características</a>
        <a href="/#nuestros-valores">Nuestros Valores</a>
        <a 
          href="#descargar" 
          className='btn-download' 
        >Descargar App</a>
        <div className='d-flex justify-content-center align-items-center'>
          <a 
            className='icon-redes'
            href="https://www.instagram.com/kuskaoficial?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==">
            <img src="/iconos/instagram.png" alt="Logo Instagram" />
          </a>
          <a 
            className='icon-redes'
            href="https://www.facebook.com/profile.php?id=61582461046207&sk=directory_contact_info" target='_blank' rel="noreferrer">
            <img src="/iconos/facebook.png" alt="Logo Facebook" />
          </a>
          <a 
            className='icon-redes'
            href="https://www.tiktok.com/@kuska90?_r=1&_t=ZM-93FMQgk7dEa" rel="noreferrer" target='_blank'>
            <img src="/iconos/tik-tok.png" alt="Logo Gmail" />
          </a>
        </div>
      </div>
    </div>
  )
}
